import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/searchspring/components/collection/filters/FilterSelected'
import { FilterSort } from '@/components/libs/searchspring/components/collection/filters/FilterSort'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { useEffect, useRef } from 'preact/hooks'
import { scrollHistoryManager } from 'helpers/scroll-history'

export function FilterDrawer({ id = 'filters', showFilters = false }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    initialFilters,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const { results, isLoading } = useInfiniteScrollResults()
  const initialLoadDone = useRef(false)
  const isDesktop = useRef(window.innerWidth >= 1024)
  const isSearch = scrollHistoryManager.getPageType() === 'search'

  useEffect(() => {
    if (showFilters && isDesktop.current && !initialLoadDone.current) {
      if (isSearch) {
        setTimeout(() => {
          document.querySelector('#toggle-filters')?.click()
          initialLoadDone.current = true
        }, 100)
      } else if (!isLoading && results) {
        document.querySelector('#toggle-filters')?.click()
        initialLoadDone.current = true
      }
    }
  }, [isLoading, results, showFilters, isSearch])

  return (
    <x-modal
      className="group/filters"
      data-id={id}
    >
      <div className="flex flex-col fixed lg:absolute top-0 lg:top-full right-0 w-fit h-view lg:h-[calc(var(--height-screen-adapt)-100%)] pointer-events-none group-data-visible/filters:pointer-events-auto overflow-hidden transition-[height] duration-300">
        <div className="lg:grow flex flex-col w-full lg:w-1/4-window h-full lg-max:max-w-[328px] bg-secondary lg:border-l lg:border-borders-default translate-x-full group-data-visible/filters:translate-x-0 z-2 transition-all">
          <div className="shrink-0 flex lg:hidden gap-x-gutter items-center justify-between w-full pl-margin lg:pr-0.375 border-b border-borders-default">
            <h2 className="paragraph-xs font-base-spaced uppercase py-0.625">Filters{activeFilters.size > 0 ? ` (${activeFilters.size})` : ''}</h2>
            <button
              className="btn btn-transparent btn-primary btn-m btn-square"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="Close Filters"
            >
              <div className="size-[9px] children:size-full">
                <Icon id="close" />
              </div>
            </button>
          </div>
          <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          <div className="grow flex flex-col overflow-y-scroll no-scrollbar">
            <FilterSort />
            {initialFilters.length > 0 ? (
              initialFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  onRemove={handleRemoveFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <div className="px-margin py-1">
                <p className="paragraph-xs text-type-black-secondary">No filters available.</p>
              </div>
            )}
          </div>
          <div className="shrink-0 flex gap-x-1 w-full p-1 -mt-px bg-secondary border-t border-borders-default z-2">
            {activeFilters.size > 0 && (
              <button
              className="grow btn btn-primary btn-border btn-m"
              onClick={handleClearFilters}
              aria-label="Clear Filters"
            >
              Clear All
            </button>
            )}
            <button
              className="grow btn btn-primary btn-fill btn-m"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="Apply Filters"
            >
              Apply Filters
            </button>
          </div>
        </div>
        <button
          class="lg:hidden fixed inset-tl size-full bg-type-black-primary/60 opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all"
          data-modal-parent={id}
          data-modal-role="close"
          aria-label="Close Filters"
        >
        </button>
      </div>
    </x-modal>
  )
}
